export default {
  isMockedLocation: (state) => state.current?.isMock === true,
  shouldBlockForMock () {
    return this.isMockedLocation && this.mockPolicy === 'block'
  }
}
